import { render, staticRenderFns } from "./TheCartExerpt.vue?vue&type=template&id=e03196a8&"
import script from "./TheCartExerpt.vue?vue&type=script&lang=js&"
export * from "./TheCartExerpt.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ITrash: require('/opt/build/repo/components/svg/Trash.vue').default,IClose: require('/opt/build/repo/components/svg/Close.vue').default,CartExerptProduct: require('/opt/build/repo/components/CartExerptProduct.vue').default,AppButton: require('/opt/build/repo/components/AppButton.vue').default})
